import { Currency as Currencies } from "@smeetz/orders";

export const CURRENCY_CHF = "CHF";
export const CURRENCY_EUR = "EUR";
export const CURRENCY_USD = "USD";
export const CURRENCY_GBP = "GBP";
export const CURRENCY_AED = "AED";

// export enum Currencies {
//   CHF = "CHF",
//   EUR = "EUR",
//   USD = "USD",
//   GBP = "GBP",
//   AED = "AED",
// }

export { Currencies };

export const CURRENCIES: string[] = ["CHF", "EUR", "USD"];

export interface detailedCurrency {
  id: string;
  label: string;
  detailedName: string;
  symbol: string;
  bills: { name: number; userInput: number; sum: number }[];
  coins: { name: number; userInput: number; sum: number }[];
  cents: { name: number; userInput: number; sum: number }[];
}

export interface Currency {
  id: number;
  isDefault: number;
  status: number;
  label: Currencies;
  exchangeRate: number;
}

export const allDetailedCurrencies: detailedCurrency[] = [
  {
    id: "CHF",
    label: "CHF",
    detailedName: "Swiss francs",
    symbol: "CHF",
    bills: [
      { name: 1000, userInput: 0, sum: 0 },
      { name: 200, userInput: 0, sum: 0 },
      { name: 100, userInput: 0, sum: 0 },
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
    ],
    coins: [
      { name: 5, userInput: 0, sum: 0 },
      { name: 2, userInput: 0, sum: 0 },
      { name: 1, userInput: 0, sum: 0 },
    ],
    cents: [
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
    ],
  },
  {
    id: "EUR",
    label: "EUR",
    detailedName: "Euro",
    symbol: "€",
    bills: [
      { name: 500, userInput: 0, sum: 0 },
      { name: 200, userInput: 0, sum: 0 },
      { name: 100, userInput: 0, sum: 0 },
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
    ],
    coins: [
      { name: 2, userInput: 0, sum: 0 },
      { name: 1, userInput: 0, sum: 0 },
    ],
    cents: [
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
      { name: 2, userInput: 0, sum: 0 },
      { name: 1, userInput: 0, sum: 0 },
    ],
  },
  {
    id: "GBP",
    label: "GBP",
    detailedName: "British Pound",
    symbol: "£",
    bills: [
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
    ],
    coins: [
      { name: 2, userInput: 0, sum: 0 },
      { name: 1, userInput: 0, sum: 0 },
    ],
    // aka pence
    cents: [
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
      { name: 2, userInput: 0, sum: 0 },
      { name: 1, userInput: 0, sum: 0 },
    ],
  },
  {
    id: "USD",
    label: "USD",
    detailedName: "U.S. Dollars",
    symbol: "$",
    bills: [
      { name: 100, userInput: 0, sum: 0 },
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
      { name: 2, userInput: 0, sum: 0 },
      { name: 1, userInput: 0, sum: 0 },
    ],
    coins: [{ name: 1, userInput: 0, sum: 0 }],
    cents: [
      { name: 50, userInput: 0, sum: 0 },
      { name: 25, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
      { name: 1, userInput: 0, sum: 0 },
    ],
  },
  {
    id: "AED",
    label: "AED",
    detailedName: "UAE Dirham",
    symbol: "AED",
    bills: [
      { name: 1000, userInput: 0, sum: 0 },
      { name: 500, userInput: 0, sum: 0 },
      { name: 200, userInput: 0, sum: 0 },
      { name: 100, userInput: 0, sum: 0 },
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
    ],
    coins: [{ name: 1, userInput: 0, sum: 0 }],
    cents: [
      { name: 50, userInput: 0, sum: 0 },
      { name: 25, userInput: 0, sum: 0 },
    ],
  },
  {
    id: "CAD",
    label: "CAD",
    detailedName: "Canadian Dollars",
    symbol: "CAD",
    bills: [
      { name: 100, userInput: 0, sum: 0 },
      { name: 50, userInput: 0, sum: 0 },
      { name: 20, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
    ],
    // $2 toonie and $1 loonie; the penny was withdrawn in 2013.
    coins: [
      { name: 2, userInput: 0, sum: 0 },
      { name: 1, userInput: 0, sum: 0 },
    ],
    cents: [
      { name: 25, userInput: 0, sum: 0 },
      { name: 10, userInput: 0, sum: 0 },
      { name: 5, userInput: 0, sum: 0 },
    ],
  },
];

/**
 * Currency symbol for a currency label (e.g. "EUR" → "€", "USD" → "$").
 * CHF and AED stay on their ISO code: "₣" is not used in Switzerland and the
 * Dirham sign is missing from current fonts.
 * Pure lookup over `allDetailedCurrencies` — safe to import into components
 * without pulling heavy accounting helpers.
 */
export function currencySymbol(label: string): string {
  return allDetailedCurrencies.find((c) => c.label === label)?.symbol || label;
}

/*
export const CURRENCIES_WITH_ID: ICurrency[] = [
  {
    id: 1,
    label: "CHF",
  },
  {
    id: 2,
    label: "EUR",
  },
  {
    id: 3,
    label: "USD",
  },
  /!*
  {
    id: 4,
    label: "GBP",
  },
  {
    id: 5,
    label: "AED",
  },
*!/
];
*/
